import { CORE_PAGES } from "./intentPages.core";
import { CLINICAL_PAGES } from "./intentPages.clinical";
import { CLUSTER2_PAGES } from "./intentPages.cluster2";
import { CLUSTER3_PAGES } from "./intentPages.cluster3";
import { CLUSTER4_PAGES } from "./intentPages.cluster4";

export const INTENT_PAGES = {
  ...CORE_PAGES,
  ...CLINICAL_PAGES,
  ...CLUSTER2_PAGES,
  ...CLUSTER3_PAGES,
  ...CLUSTER4_PAGES,
};
export const INTENT_SLUGS = Object.keys(INTENT_PAGES);
